(function(){
  'use strict';

  var config=window.NNPostHogConfig||{};
  var token=String(config.projectToken||'').trim();
  var apiHost=String(config.apiHost||'https://us.i.posthog.com').replace(/\/$/,'');
  var initialized=false;
  var recentCaptures={};
  var trackedEvents=[
    'cart_open',
    'cart_add',
    'cart_change',
    'cart_upsell_view',
    'cart_upsell_add',
    'begin_checkout',
    'search_open',
    'search_query',
    'search_no_results',
    'search_result_click',
    'search_view_all',
    'search_quick_add',
    'batch_record_open',
    'batch_source_click'
  ];

  if(!token||!/^https:\/\//i.test(apiHost))return;

  function analyticsAllowed(){
    var privacy=window.Shopify&&window.Shopify.customerPrivacy;
    if(!privacy)return false;
    try{
      if(typeof privacy.analyticsProcessingAllowed==='function')return Boolean(privacy.analyticsProcessingAllowed());
      if(typeof privacy.currentVisitorConsent==='function')return privacy.currentVisitorConsent().analytics==='yes';
    }catch(error){}
    return false;
  }

  function capture(name,detail){
    if(!initialized||!window.posthog||typeof window.posthog.capture!=='function')return;
    var now=Date.now();
    if(recentCaptures[name]&&now-recentCaptures[name]<400)return;
    recentCaptures[name]=now;
    window.posthog.capture('nn_'+name,detail&&typeof detail==='object'?detail:{});
  }

  function bindEvents(){
    trackedEvents.forEach(function(name){
      window.addEventListener('nn:'+name,function(event){
        capture(name,event&&event.detail);
      });
    });
  }

  function trackInstrumentedClick(event){
    var target=event.target&&event.target.closest?event.target.closest('[data-nn-search-open],[data-nn-cart-open],[data-nnbr-open]'):null;
    if(!target)return;
    if(target.matches('[data-nn-search-open]'))capture('search_open',{entry:'header'});
    else if(target.matches('[data-nn-cart-open]'))capture('cart_open',{source:'header_or_navigation'});
    else if(target.matches('[data-nnbr-open]'))capture('batch_record_open',{source:'batch_record_trigger'});
  }

  function loadSdk(){
    if(initialized||!analyticsAllowed())return;
    initialized=true;

    (function(document,window){
      if(window.posthog&&window.posthog.__SV)return;
      var library;
      var posthog=window.posthog=window.posthog||[];
      posthog._i=posthog._i||[];
      posthog.init=function(projectToken,config,name){
        function stub(target,method){
          var parts=method.split('.');
          if(parts.length===2){target=target[parts[0]];method=parts[1];}
          target[method]=function(){target.push([method].concat(Array.prototype.slice.call(arguments,0)));};
        }
        var sdk=document.createElement('script');
        sdk.type='text/javascript';
        sdk.crossOrigin='anonymous';
        sdk.async=true;
        sdk.src=config.api_host.replace('.i.posthog.com','-assets.i.posthog.com')+'/static/array.js';
        library=document.getElementsByTagName('script')[0];
        library.parentNode.insertBefore(sdk,library);
        var instance=name?posthog[name]=[]:posthog;
        instance.people=instance.people||[];
        var methods='capture register register_once register_for_session unregister unregister_for_session getFeatureFlag getFeatureFlagResult isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags resetGroupPropertiesForFlags resetPersonProperties reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty createPersonProfile opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing debug'.split(' ');
        for(var index=0;index<methods.length;index+=1)stub(instance,methods[index]);
        instance._i.push([projectToken,config,name]);
      };
      posthog.__SV=1;
    })(document,window);

    window.posthog.init(token,{
      api_host:apiHost,
      defaults:'2026-05-30',
      autocapture:true,
      capture_pageview:true,
      capture_pageleave:true,
      person_profiles:'identified_only'
    });
  }

  function optOut(){
    if(window.posthog&&typeof window.posthog.opt_out_capturing==='function')window.posthog.opt_out_capturing();
  }

  function initPrivacyApi(attempt){
    attempt=attempt||0;
    if(window.Shopify&&window.Shopify.customerPrivacy){
      if(analyticsAllowed())loadSdk();
      return;
    }
    if(window.Shopify&&typeof window.Shopify.loadFeatures==='function'){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],function(error){
        if(!error)initPrivacyApi(13);
        else if(attempt<12)window.setTimeout(function(){initPrivacyApi(attempt+1);},250);
      });
      return;
    }
    if(attempt<12)window.setTimeout(function(){initPrivacyApi(attempt+1);},250);
  }

  window.addEventListener('nn:privacy_consent',function(event){
    var consent=event&&event.detail||{};
    if(consent.analytics===true)loadSdk();
    else if(consent.analytics===false)optOut();
  });

  window.NNPostHog={capture:capture};
  bindEvents();
  document.addEventListener('click',trackInstrumentedClick,true);
  initPrivacyApi();
})();